import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ItemType, useTopicPage_Views_LabelsQuery, TopicPage_Views_Labels_LabelsUpdatedDocument } from "sprout-graphql";
import { useParams } from "react-router-dom";
import useLoadingProgress from "@sprout/hooks/dist/useLoadingProgress";
import { Glitch, NotFound } from "@sprout/views";
import FeatureFlaggedSubscription from "@sprout/client-lib/dist/FeatureFlaggedSubscription";
import TopicPageViewsLabelsPage from "./TopicPageViewsLabelsPage";
const TopicPageViewsLabels = ()=>{
    const { topicId  } = useParams();
    const { loading , data , error  } = useTopicPage_Views_LabelsQuery({
        variables: {
            topicId: Number(topicId)
        },
        fetchPolicy: "cache-and-network"
    });
    const topic = data === null || data === void 0 ? void 0 : data.topic;
    const isInitialLoad = loading && !topic;
    useLoadingProgress(isInitialLoad);
    if (isInitialLoad) return null;
    if (error) return /*#__PURE__*/ _jsx(Glitch, {
        error: error
    });
    if (!topic || topic.type !== ItemType.Topic || !topic.isRootTopic || topic.special === "PROFILE") return /*#__PURE__*/ _jsx(NotFound, {});
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FeatureFlaggedSubscription, {
                subscription: TopicPage_Views_Labels_LabelsUpdatedDocument,
                variables: {
                    topicId: topic.id
                }
            }),
            /*#__PURE__*/ _jsx(TopicPageViewsLabelsPage, {
                topic: topic
            })
        ]
    });
};
export default TopicPageViewsLabels;
